import {
  Text,
  IconSignature,
  IconCircleX,
  GreyGrey70,
  Primary13Regular,
  Primary13SemiBold
} from '@sequencehq/core-components'

import { NodeTimeline, QuotePreviewCard } from 'Automations/components'
import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { TaskInput } from './types'
import { useQuoteData } from '../../hooks/useQuoteData'
import { ExecuteQuoteAction } from '../../components/ExecuteQuoteAction'

export const QuoteAutoExecuteFailedPreview = (props: { taskId: string }) => {
  const { manualTask } = useManualTask({ taskId: props.taskId })
  const input = manualTask?.input as TaskInput | undefined
  const { quote, customer } = useQuoteData(input?.quoteId)

  const hasQuoteData = quote && customer

  return (
    <>
      <NodeTimeline.Item icon={<IconSignature />} showStem>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label="Quote created"
            timestamp={quote?.createdAt}
          />
        </NodeTimeline.Title>

        {hasQuoteData && (
          <QuotePreviewCard quote={quote} customer={customer} startCollapsed />
        )}
      </NodeTimeline.Item>

      <NodeTimeline.Item icon={<IconCircleX />} showStem={false} highlightIcon>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label={
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                Auto-execute failed
              </Text>
            }
            timestamp={manualTask?.createdAt}
          />
        </NodeTimeline.Title>

        <Text {...Primary13Regular} color={GreyGrey70} marginBottom="16px">
          This quote failed to automatically execute after signing. To resolve,
          try manually creating a billing schedule to execute the quote.
        </Text>

        {hasQuoteData && input && (
          <QuotePreviewCard
            quote={quote}
            customer={customer}
            action={<ExecuteQuoteAction quoteId={input.quoteId} />}
          />
        )}
      </NodeTimeline.Item>
    </>
  )
}
